import PricingPage from "pages/PricingPage";
import React from "react";

const PricingRoute = () => <PricingPage />;

export default PricingRoute;
